import { Container, Term } from './styled';
export function Item(props) {
    const { term, children } = props;
    return (<Container>
      <Term>{term}</Term>
      {children}
    </Container>);
}
